
<div class="container-fluid">

    <app-header></app-header>
    
    <div class="row mt-3 d-flex justify-content-center signup-card">
        <div class="col-lg-3 col-xs-12 col-sm-12 col-md-12 col-md-mid-lg-4">
            <div class="text-center box-white">
             
                <div class=" white-bg pt-0 pl-2 pr-2 pt-4">
                    <h5 class="text-center payment-success"><b> Success,  </b> <br> <b> payment verified! </b></h5> 
                   
                    
                     
                    
                    <!-- <img src="assets/images/orderCode.jpg" alt="Logo" width="100%">   -->

                    <h4 class="pt-4 text-center ordering-font"><span style="font-size: 1rem; ">Order </span>  </h4> 
                    <p class="text-center ft-size-16 ordering-font font-wight-bold"> #<b>{{orderNo}} </b> </p> 
                    <h4 class="  text-center ordering-font mt-0 pt-0" *ngIf="storecode"><span style="font-size: 1rem;">Store Reference </span>  </h4>
                    <p class="text-center pb-4 ft-size-16 ordering-font font-wight-bold"  *ngIf="storecode"> #<b>{{storecode}}</b> </p>
 
                    <hr>

                    <div class="row  clearfix" >
                        <div class="col-5">
                            <p class="text-left  ">Order value</p> 
                        </div>
                        <div class="col-7">
                            <p class="text-right mb-0 line-h-30"> <span class="ft-size-20 number-font"> Rs  </span> <span class="ft-size-25 number-font  "   > {{ this.totalfirstval   }}</span> <span class="ft-size-18 number-font  " >.{{ this.totalsecondval }}</span>  </p> 
                        </div> 
                    </div>

                     

                    <button class="btn btn-secondary form-control back-to-cas mt-3 mb-3 no-border-radius " (click)="backtohome()"> <b> BACK TO CASHIER PORTAL </b></button>
                </div> 
                
            </div>
            
        </div>
        <div class="col-lg-9 col-md-mid-lg-8"> 
            &nbsp;
        </div>
    </div>
 
  
</div>

<div class="foter-mr-pd-fix ">
    <app-footer></app-footer>
</div>